<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-text-field
          label="Фамилия"
          outlined
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Имя"
          outlined
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.birthDate.$model"
          :errorMessage="v.birthDate"
          :max="new Date().toISOString()"
          @change="v.birthDate.$model = $event"
        />
      </v-col>

      <v-col cols="4">
        <v-autocomplete
          v-model="v.regionCode.$model"
          outlined
          label="Субъект Российской Федерации"
          item-text="regionName"
          item-value="regionCode"
          :errorMessages="getValidationErrorText(v.regionCode)"
          :items="regions"
          :filter="
            (item, queryText) => {
              return (
                item.regionName
                  .toLocaleLowerCase()
                  .indexOf(queryText.toLocaleLowerCase()) > -1
              );
            }
          "
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{ data.item.regionName }}</v-list-item-title>
              <v-list-item-subtitle>
                код региона: {{ data.item.regionCode }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">Документ, удостоверяющий личность</div>
      </v-col>
    </v-row>

    <IdentityDocument :v="v.identityDocument" :documents="identityDocuments" />

    <AttachDocumentSingle
      :value="{
        file: v.identityDocument.file.$model,
        fileSig: v.identityDocument.fileSig.$model,
      }"
      :error-messages="getValidationErrorText(v.identityDocument.file)"
      @change="
        v.identityDocument.file.$model = $event.file;
        v.identityDocument.fileSig.$model = $event.fileSig;
      "
    />
  </div>
</template>

<script>
import { and, maxLength, required } from 'vuelidate/lib/validators';

import DateFieldCustom from '@/components/base/DateFieldCustom';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  getValidationErrorText,
  PERSON_NAME,
} from '@/utils/validate';
import IdentityDocument, {
  identityDocumentModel,
  identityDocumentValidation,
} from '@/components/services/elements/IdentityDocument';
import { IdentityDocumentsModule } from '@/store/modules/identityDocuments';

export const personModel = {
  isBusinessman: false,
  lastName: '',
  firstName: '',
  patronymic: '',
  birthDate: '',
  regionCode: '',
  identityDocument: {
    ...identityDocumentModel,
    file: null,
    fileSig: null,
  },
};

export const personValidation = {
  lastName: {
    required,
    maxLength: maxLength(60),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(60),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(60),
    PERSON_NAME,
  },
  birthDate: {
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  regionCode: {},
  identityDocument: {
    ...identityDocumentValidation,
    file: {},
    fileSig: {},
  },
};

export default {
  props: {
    v: {
      type: Object,
      required: true,
    },
    regions: {
      type: Array,
      required: true,
    },
  },
  components: {
    IdentityDocument,
    DateFieldCustom,
    AttachDocumentSingle,
  },
  data: () => ({
    getValidationErrorText,
  }),
  computed: {
    identityDocuments() {
      return IdentityDocumentsModule.list;
    },
  },
  async mounted() {
    if (!IdentityDocumentsModule.loading && !IdentityDocumentsModule.loaded) {
      await IdentityDocumentsModule.loadIdentityDocumentsAll();
    }
  },
};
</script>
